'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Button } from '@workspace/ui';
import { markAllNotificationsAsRead } from '@/actions/notification';

interface NotificationMarkAllButtonProps {
  disabled?: boolean;
}

export function NotificationMarkAllButton({ disabled = false }: NotificationMarkAllButtonProps) {
  const queryClient = useQueryClient();

  const markAllAsReadMutation = useMutation({
    mutationFn: markAllNotificationsAsRead,
    onError: (err) => {
      console.error('Failed to mark all notifications as read:', err);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });

  const handleMarkAllAsRead = async () => {
    try {
      await markAllAsReadMutation.mutateAsync();
    } catch (error) {
      console.error('Failed to mark all notifications as read:', error);
    }
  };

  return (
    <Button
      variant="pink-ghost"
      className="text-sm! lg:text-base!"
      onClick={handleMarkAllAsRead}
      aria-label={'Mark all as read'}
      disabled={disabled || markAllAsReadMutation.isPending}
    >
      {'Mark all as read'}
    </Button>
  );
}
